import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Button, Typography } from '@mui/material'

import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function CycleAllocatedTokens() {

    const karmaContext = useKarmaPoolContext();

    const [allocatedTokens, setAllocatedTokens] = useState(0);

    useEffect(() => {
        console.log("setAllocatedTokens useEffect")

        if (karmaContext.local.user === undefined || karmaContext.local.user === null) {
            return;
        }

        setAllocatedTokens(karmaContext.local.user.tokensAllocatedToCycle);
    }, [karmaContext.local]);

    if (karmaContext.local !== undefined && karmaContext.local.user != null && !karmaContext.local.user.member) {
        return (
            <></>
        );
    }

    return (
        <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.0rem", color: "whitesmoke" }}>
            You have allocated <strong>{allocatedTokens}</strong> of <strong>
                {karmaContext.local.user === undefined || karmaContext.local.user === null ? "" : karmaContext.local.user['tokens']}
            </strong> of your tokens
        </Typography>
    );
}

export default CycleAllocatedTokens;


